<template>
  <div>
    <form
      class="register"
      method="post"
      action="/"
      @submit.prevent="register"
      autocomplete="off"
    >
      <input
        :placeholder="translations[language][USERNAME]"
        type="text"
        id="username"
        name="username"
        style="opacity: 0; position: absolute; top: 0"
      />
      <input
        :placeholder="translations[language][PASSWORD]"
        id="password"
        name="password"
        type="password"
        style="opacity: 0; position: absolute; top: 0"
      />
      <input
        :placeholder="translations[language][USERNAME]"
        v-model="userName"
        type="text"
        id="newUsername"
        class="general-input"
        name="newUsername"
        required
        style="position: relative; z-index: 2"
      />
      <input
        :placeholder="translations[language][PASSWORD]"
        v-model="password"
        type="password"
        id="newPassword"
        class="general-input"
        name="newPassword"
        required
      />
      <input
        :placeholder="translations[language][CONFIRM_PASSWORD]"
        type="password"
        v-model="confirmPassword"
        id="confirmpass"
        class="general-input"
        name="confirmpass"
        required
      />
      <input
        :placeholder="translations[language][FULL_NAME]"
        v-model="fullName"
        type="text"
        id="fullName"
        class="general-input"
        name="newFullName"
        required
      />
      <input
        placeholder="Email"
        v-model="email"
        type="email"
        id="newEmail"
        class="general-input"
        name="newEmail"
        required
      />
      <select
        v-if="groups && $store.getters.accType !== 'VzAdmin'"
        name="groupName"
        id="groupName"
        v-model="groupName"
        required
      >
        <option v-for="(group, index) in groups" :key="index" :value="group.group_name">
          {{ group.group_name }}
        </option>
      </select>
      <button
        type="submit"
        value="Register"
        :class="{
          root: $store.getters.accType === 'Root' || $store.getters.accType === 'VzAdmin',
        }"
      >
        <span v-if="loader"><Loader color="#fff"/></span>
        <span v-else>{{ parseTranslation(CREATE_USER) }}</span>
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import * as translationUserRegister from './UserRegister.translations'

const { default: translations, ...translationKeys } = translationUserRegister

export default {
  name: 'register',

  components: {
    Loader,
  },
  data() {
    return {
      translations,
      ...translationKeys,
      state: 0,
      groupName: '',
      groups: null,
      loader: false,
      userName: '',
      password: '',
      confirmPassword: '',
      fullName: '',
      email: '',
    }
  },

  watch: {
    userName(value) {
      this.userName = value.replace(/_|[\W]|\\./g, '')
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall', 'addNewUser']),

    async getGroups() {
      if (this.$store.getters.accType !== 'Root') return

      const groups = await this.executeSurveyAPICall({
        path: '/groups/list',
      })

      if (!groups) return

      this.groups = groups
    },

    async register() {
      if (this.loader) return

      this.loader = true

      const regexpEmail = /[\w.-]+@[\w-]+\.[\w-.]+/gi

      if (this.password !== this.confirmPassword) {
        this.loader = false

        return this.sendMessage(
          this.translations[this.language][this.VALIDATION_PASSWORD],
        )
      }

      if (!this.email.match(regexpEmail)) {
        this.loader = false

        return this.sendMessage(this.translations[this.language][this.VALIDATION_EMAIL])
      }

      const createdUser = await this.executeSurveyAPICall({
        method: 'POST',
        path: 'user',
        payload: {
          username: this.userName,
          password: this.password,
          fullName: this.fullName,
          email: this.email,
          group_name: this.groupName,
        },
      })

      if (!createdUser) return (this.loader = false)

      this.userName = ''
      this.password = ''
      this.confirmPassword = ''
      this.fullName = ''
      this.email = ''

      this.groupName = this.$store.getters.groupName
      this.sendMessage(this.translations[this.language][this.USER_REGISTERED])

      this.addNewUser(createdUser)

      this.state = 0
      this.loader = false
    },
  },

  created() {
    this.groupName = this.$store.getters.groupName
    this.getGroups()
  },
}
</script>

<style lang="scss" scoped>
.register {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @include d(s) {
    justify-content: center;
  }
  input,
  select {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    padding: 0px 10px;
    border-radius: 15px;
    margin: 10px;
    height: 25px;
    width: 150px;
    color: $white;

    &:focus {
      outline: none;
      box-shadow: 0px 0px 6px $gray;
    }
  }
  option {
    color: $gray-6;
  }
  ::placeholder {
    color: $white;
    opacity: 1;
  }

  ::-webkit-input-placeholder {
    color: $white;
  }

  :-moz-placeholder {
    color: $white;
  }

  ::-moz-placeholder {
    color: $white;
  }

  :-ms-input-placeholder {
    color: $white;
  }
  button[type='submit'] {
    @include btn-style;
    text-transform: initial;
    padding: 5px 17px;
    margin: 5px 10px;
    width: unset;
    &.root {
      margin-left: auto;
      @include d(s) {
        margin-left: unset;
      }
    }
  }
  .light & {
    input,
    select {
      border: 1px solid $gray-5;
      background: rgba(0, 0, 0, 0);
      color: $gray-6;
    }
    ::placeholder {
      color: $gray-6;
      opacity: 1;
    }
    ::-webkit-input-placeholder {
      color: $gray-6;
    }

    :-moz-placeholder {
      color: $gray-6;
    }

    ::-moz-placeholder {
      color: $gray-6;
    }

    :-ms-input-placeholder {
      color: $gray-6;
    }
  }
}
</style>
